export default __webpack_public_path__ + "static/media/edit.dbb3376b.svg";